exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#footer[data-v-5537bc92]{background:#dedede}#footer p[data-v-5537bc92]{font-size:.75rem;padding-top:15px}#footer[data-v-5537bc92]{height:100px;padding:0 150px}#footer p[data-v-5537bc92]{text-align:right}@media (max-width:768px){#footer[data-v-5537bc92]{height:100px;padding:0 100px!important}#footer p[data-v-5537bc92]{text-align:center!important}}@media (max-width:576px){#footer[data-v-5537bc92]{height:100px;padding:0 50px!important}#footer p[data-v-5537bc92]{text-align:center!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5537bc92","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/overall_layouts/footer.vue
// module id = 593
// module chunks = 0